import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { useState } from 'react';
import { Avatar } from './avatar';
import { Flex } from '../layout';
import styled from '../../styles/styled';
export const AvatarWithBadge = ({ statusColor, ...props }) => {
    const [hovered, setHovered] = useState(false);
    return (_jsxs(StatusWrapper, { onMouseEnter: () => setHovered(true), onMouseLeave: () => setHovered(false), statusColor: statusColor, children: [_jsx(Avatar, { ...props }), hovered && _jsx(Overlay, {})] }));
};
const StatusWrapper = ({ children, statusColor, onMouseEnter, onMouseLeave, }) => {
    return (_jsxs(Container, { onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, children: [statusColor && (_jsx(Notification, { color: statusColor, alignItems: "center", justifyContent: "center", borderRadius: 50 })), children] }));
};
export const Notification = styled(Flex)(({ color, theme }) => ({
    position: 'absolute',
    bottom: 0,
    zIndex: 1,
    right: 2,
    height: '10px',
    width: '10px',
    background: color,
    border: `solid 1px ${theme.colors.blue90}`,
}));
export const Container = styled.div({
    position: 'relative',
    display: 'flex',
    alignContent: 'center',
});
export const Overlay = styled.div({
    position: 'absolute',
    height: '40px',
    width: '40px',
    borderRadius: '50px',
    backgroundColor: 'rgba(0,0,0,0.1)',
});
//# sourceMappingURL=avatar_with_badge.js.map